export const environment = {
  isProduction: false,
  name: 'Local',
  issuer: 'https://sso-uat.fybros.com',
  baseUrl: 'https://api.carvia-test.org/fynite-fybros-service',
};